import { axiosGet, axiosPost } from "./axiosFunctions";
import { getAuthState } from "../../assets/scripts/login-util";
import { secretKey } from "../../env.json";
import { Encryptor } from "../../components/global/encryptor";

const { generateHmac } = Encryptor(secretKey);

const getCashCardDataUrl = '/api/cashCard/getCashCardData';
const processCashCardPaymentUrl = '/api/cashCard/postCashCardPayment';
const cancelCashCardTransactionUrl = '/api/cashCard/cancelTransaction';

// API functions for cash card payments
/**
 * Get cash card data for the current order session
 * @returns {Promise<Object>} The cash card data including list of available cards
 */

export const getCashCardData = async (data, sig) => {
    // const token = getAuthState('token');
    // if (!token) {
    //   setTimeout(() => { window.open('/', '_self'); }, 2000);
    //   return;
    // }

    const response = await axiosPost(
    getCashCardDataUrl,
    { data, sig },
    // { headers: { auth_token: `bearer ${token}` } }
    );
    return response;

  };
  


/**
 * Process payment using selected cash card
 * @param {Object} paymentData - Payment data including orderId and cardNumber
 * @returns {Promise<Object>} Payment result
 */
export const postCashCardPayment = async (data,sig,cardNumber) => {
    // const token = getAuthState('token');
    // if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);
    
    const response = await axiosPost(
        processCashCardPaymentUrl,
        { data,sig,cardNumber },
        // { headers: { auth_token: `bearer ${token}` }}
    );
    return response;

};

/**
 * Cancel the transaction
 * @param {Object} data - Data containing orderId
 * @returns {Promise<Object>} Cancellation result
 */
export const cancelCashCardTransaction = async (data,sig) => {
    // const token = getAuthState('token');
    // if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);
    const response = await axiosPost(
        cancelCashCardTransactionUrl,
        { data,sig },
        // { headers: { auth_token: `bearer ${token}` }}
    );
    return response;
};

/**
 * Mock data for development/testing
 * @returns {Object} Mock cash card data
 */
export const mockCashCardData = () => {
    return {
        OrderID: 'ORD12345',
        Amount: '500',
        PaymentTimeOut: new Date(Date.now() + 5 * 60 * 1000).toISOString(), // 5 minutes from now
        CashCardList: [
            {
                CardNo: '123456789',
                CardAmt: '1000'
            },
            {
                CardNo: '987654321',
                CardAmt: '2000'
            },
            {
                CardNo: '555555555',
                CardAmt: '1500'
            }
        ]
    };
};